import { createSlice } from "@reduxjs/toolkit";
import * as action from "../actions/postActions";

export const postSlicer = createSlice({
  name: "post",
  initialState: {
    loading: false,
    allPosts: null,
    allVideos: null,
    trendingPosts: null,
    pollPosts: null,
    racePosts: null,
    marketPosts: null,
    // hashtagPosts: null,
    hashtagPosts: {},
    searchPosts: null,
    searchUsers: null,
    trends: null,
    followingPosts: null,
    postById: null,
    postPreviews: {}, // Store multiple post previews by ID
    modifiedPost: null,
    newPost: null,
    newRepost: null,
    error: null,
  },
  extraReducers: {
    [action.getAllPosts.pending]: (state) => {
      state.loading = true;
    },
    [action.getTrendingPosts.pending]: (state) => {
      state.loading = true;
    },
    [action.getAllVideos.pending]: (state) => {
      state.loading = true;
    },
    [action.getMarketPosts.pending]: (state) => {
      state.loading = true;
    },
    [action.getHashtagPosts.pending]: (state) => {
      state.loading = true;
    },
    [action.searchPosts.pending]: (state) => {
      state.loading = true;
    },
    [action.getTrends.pending]: (state) => {
      state.loading = true;
    },
    [action.getFollowingPosts.pending]: (state) => {
      state.loading = true;
    },
    [action.getPostById.pending]: (state) => {
      state.loading = true;
    },
    [action.getPostPreview.pending]: (state) => {
      state.loading = true;
    },
    [action.getAllPosts.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.allPosts = data;
      } else {
        state.error = data;
      }
      state.loading = false;
    },
    [action.getTrendingPosts.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.trendingPosts = data;
      } else {
        state.error = data;
      }
    },
    [action.getRacePosts.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.racePosts = data;
      } else {
        state.error = data;
      }
    },
    [action.getPollPosts.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.pollPosts = data;
      } else {
        state.error = data;
      }
    },
    [action.getMarketPosts.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.marketPosts = data;
      } else {
        state.error = data;
      }
    },
    [action.getHashtagPosts.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      const { tag } = action.meta.arg;
      if (status === 200) {
        state.hashtagPosts[tag] = data;
      } else {
        state.error = data;
      }
    },
    [action.searchPosts.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.searchPosts = data.posts;
        state.searchUsers = data.users;
      } else {
        state.error = data;
      }
    },
    [action.getTrends.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.trends = data;
      } else {
        state.error = data;
      }
    },
    [action.deleteTrend.fulfilled]: (state, action) => {
      const { status, data } = action.payload || {};
      if (status !== 200) {
        state.error = data;
      }
    },
    [action.joinHashtag.fulfilled]: (state, action) => {
      const { status, data } = action.payload || {};
      if (status !== 200) {
        state.error = data;
      }
    },
    [action.leaveHashtag.fulfilled]: (state, action) => {
      const { status, data } = action.payload || {};
      if (status !== 200) {
        state.error = data;
      }
    },
    [action.getFollowingPosts.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.followingPosts = data;
      } else {
        state.error = data;
      }
      state.loading = false;
    },
    [action.getPostById.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.postById = data[0];
      } else {
        state.error = data;
      }
      state.loading = false;
    },
    [action.getPostPreview.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      const postId = action.meta.arg;
      if (status === 200) {
        state.postPreviews[postId] = data[0];
      } else {
        state.error = data;
      }
      state.loading = false;
    },
    [action.likePost.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.modifiedPost = data;
        // --- NEW: Update the post inside all our feed arrays! ---
        if (state.trendingPosts) {
          state.trendingPosts = state.trendingPosts.map((post) =>
            post._id === data._id ? data : post,
          );
        }
        // if (state.allPosts) {
        //   state.allPosts = state.allPosts.map((post) =>
        //     post._id === data._id ? data : post,
        //   );
        // }
        // if (state.followingPosts) {
        //   state.followingPosts = state.followingPosts.map((post) =>
        //     post._id === data._id ? data : post,
        //   );
        // }
        if (state.postById && state.postById._id === data._id) {
          state.postById = data;
        }
        // --------------------------------------------------------
      } else {
        state.errors = data;
      }
    },
    [action.unlikePost.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.modifiedPost = data;
        // --- NEW: Do the exact same thing for unliking ---
        if (state.trendingPosts) {
          state.trendingPosts = state.trendingPosts.map((post) =>
            post._id === data._id ? data : post,
          );
        }
        // if (state.allPosts) {
        //   state.allPosts = state.allPosts.map((post) =>
        //     post._id === data._id ? data : post,
        //   );
        // }
        // if (state.followingPosts) {
        //   state.followingPosts = state.followingPosts.map((post) =>
        //     post._id === data._id ? data : post,
        //   );
        // }
        if (state.postById && state.postById._id === data._id) {
          state.postById = data;
        }
        // -------------------------------------------------
      } else {
        state.errors = data;
      }
    },
    [action.ratePost.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.modifiedPost = data;
      } else {
        state.errors = data;
      }
    },
    [action.pollVote.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.modifiedPost = data;
      } else {
        state.errors = data;
      }
    },
    [action.newRepost.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.newRepost = data;
      } else {
        state.errors = data;
      }
    },
    [action.newPost.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.newPost = data;
      } else {
        state.errors = data;
      }
    },
    [action.newReply.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.newPost = data;
        // Add reply to current post if IDs match
        if (
          state.postById &&
          String(state.postById._id) === String(action.meta.arg.id)
        ) {
          if (!state.postById.replies) state.postById.replies = [];
          state.postById.replies.unshift(data);
        }
      } else {
        state.errors = data;
      }
    },
    [action.deletePost.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.modifiedPost = data;
      } else {
        state.errors = data;
      }
    },
    [action.pinPost.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.modifiedPost = data?.post || data;
      } else {
        state.error = data;
      }
    },
    [action.unpinPost.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.modifiedPost = data?.post || data;
      } else {
        state.error = data;
      }
    },
    [action.featurePost.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.modifiedPost = data?.post || data;
      } else {
        state.error = data;
      }
    },
    [action.unfeaturePost.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.modifiedPost = data?.post || data;
      } else {
        state.error = data;
      }
    },
    [action.getAllVideos.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.allVideos = data;
      } else {
        state.errors = data;
      }
      state.loading = false;
    },
    // [action.editPost.fulfilled]: (state, action) => {
    //   const { status, data } = action.payload;
    //   if (status === 200) {
    //     state.modifiedPost = data;
    //   } else {
    //     state.errors = data;
    //   }
    // },
  },
});

export default postSlicer.reducer;
